"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeOverflowShorthand = exports.openOverflowShorthand = void 0;
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var getOverflowShorthandParts = function () {
    return [
        {
            prop: 'overflow-x',
            dataType: css_data_types_1.overflowDataType,
            partOpener: (0, shorthand_parser_utils_1.splitSimpleShorthandOpener)(['overflow-x', 'overflow-y']),
        },
        {
            prop: 'overflow-y',
            dataType: css_data_types_1.overflowDataType,
        },
    ];
};
// overflow
var openOverflowShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'overflow',
        parts: getOverflowShorthandParts(),
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openOverflowShorthand = openOverflowShorthand;
var closeOverflowShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.createShorthandCloserTemplateFromParts)(getOverflowShorthandParts()));
};
exports.closeOverflowShorthand = closeOverflowShorthand;
//# sourceMappingURL=overflow-shorthand.js.map